import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'COMPANIES',
    itemActionName: 'COMPANY',
});
